import {
    FORUM_FEED_FETCH_FAILURE,
    FORUM_FEED_FETCH_REQUEST,
    FORUM_FEED_FETCH_SUCCESS,
    ForumFeedFetchFailureAction,
    ForumFeedFetchRequestAction,
    ForumFeedFetchSuccessAction,
} from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.actions';
import { HINTS_CLOSE_HINT, HintsCloseHintAction } from 'mk2/apps/users/containers/Hints/Hints.actions';
import { FORUM_FEED_HINT_NAME } from 'mk2/apps/users/containers/Hints/Hints.constants';
import { tupdate } from 'mk2/helpers/types';
import infiniteList, { State as InfiniteListState } from 'mk2/reducers/infiniteList';
import { Reducer } from 'redux';

export const ORDER_BY_NEWEST = 'newest';
export const ORDER_BY_UPDATED = 'updated';

export type OrderBy = typeof ORDER_BY_NEWEST | typeof ORDER_BY_UPDATED;

export type ForumFeedInfiniteListState = InfiniteListState;

const forumFeedInfiniteListReducer = infiniteList<ForumFeedFetchRequestAction, ForumFeedFetchSuccessAction, ForumFeedFetchFailureAction>(
    'FORUM_FEED_FETCH',
    (a) => a.response.result.posts,
);

type ForumFeedByOrderingState = {
    [orderBy in OrderBy]?: ForumFeedInfiniteListState;
};

export interface ForumFeedPageState {
    orders: ForumFeedByOrderingState;
    showHint: boolean;
    brandDaysCampaignId: number;
    brandDaysPostsIds: number[];
}

export const initialForumFeedPageState: ForumFeedPageState = {
    orders: {},
    showHint: false,
    brandDaysCampaignId: null,
    brandDaysPostsIds: [],
};

declare type ForumFeedPageReducerAction =
    ForumFeedFetchFailureAction
    | ForumFeedFetchRequestAction
    | ForumFeedFetchSuccessAction
    | HintsCloseHintAction;

const forumFeedPageReducer: Reducer<ForumFeedPageState> = (state = initialForumFeedPageState, action: ForumFeedPageReducerAction) => {
    switch (action.type) {
        case FORUM_FEED_FETCH_FAILURE:
        case FORUM_FEED_FETCH_REQUEST:
            return tupdate(state, {
                orders: tupdate(state.orders, {
                    [action.orderBy]: forumFeedInfiniteListReducer(state.orders[action.orderBy], action),
                }),
            });

        case FORUM_FEED_FETCH_SUCCESS:
            return tupdate(state, {
                orders: tupdate(state.orders, {
                    [action.orderBy]: forumFeedInfiniteListReducer(state.orders[action.orderBy], action),
                }),
                showHint: action.showHint,
                brandDaysCampaignId: action.response.result.brandDays.campaign,
                brandDaysPostsIds: action.response.result.brandDays.posts,
            });

        case HINTS_CLOSE_HINT:
            return (action.name === FORUM_FEED_HINT_NAME)
                ? tupdate(state, {
                    showHint: false,
                })
                : state;

        default:
            return state;
    }
};

export default forumFeedPageReducer;
